import React, { forwardRef, MutableRefObject } from 'react';
import { Box } from '@material-ui/core';
import { FormikProps } from 'formik';

import { FormikNotifier } from 'components';
import { ContentInput } from 'api';
import { useCapabilities } from 'hooks';

import {
  ExternalShareOption,
  PhotoStrip,
  UploadSection,
  UrlField,
  UrlPreview,
  usePostContext,
} from 'features/posting';
import { ComposeTabBody } from 'features/compose';
import { Share } from 'features/sharing/types';

interface Props {
  onUpdate: (values: Share) => void;
}

const PostFormBody = forwardRef<FormikProps<ContentInput>, Props>(({ onUpdate }, ref) => {
  const { isAdmin, isModerator } = useCapabilities();
  const { state } = usePostContext();

  const typedFormikShareRef = ref as MutableRefObject<FormikProps<ContentInput>>;

  function renderLink() {
    return (
      <ComposeTabBody>
        <UrlField />
        {state.validUrl && <UrlPreview moderator={isAdmin || isModerator} />}
      </ComposeTabBody>
    );
  }

  function renderImage() {
    const { values } = typedFormikShareRef.current;
    const { photos } = values.content_object;

    return (
      <ComposeTabBody>
        <UploadSection />
        {!!photos.length && (
          <Box marginBottom={-1}>
            <PhotoStrip />
          </Box>
        )}
      </ComposeTabBody>
    );
  }

  return (
    <FormikNotifier onChange={onUpdate}>
      {state.shareOption === ExternalShareOption.LinkShare && renderLink()}
      {state.shareOption === ExternalShareOption.ImageShare && renderImage()}
    </FormikNotifier>
  );
});

export default PostFormBody;
